import { render, staticRenderFns } from "./ItemGrid.vue?vue&type=template&id=c4de4f50&scoped=true"
import script from "./ItemGrid.vue?vue&type=script&lang=js"
export * from "./ItemGrid.vue?vue&type=script&lang=js"
import style0 from "./ItemGrid.vue?vue&type=style&index=0&id=c4de4f50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4de4f50",
  null
  
)

export default component.exports